import { t } from 'ember-intl';
import { LayoutLoading } from 'core/components';

<template>
  <LayoutLoading class="layout--with-sidebar">
    <LayoutLoading as |L|>
      <L.Message>
        {{t "components.layout.loading.loading-overview"}}
      </L.Message>
    </LayoutLoading>
  </LayoutLoading>
</template>
